<template>
  <header>
    <img
      src="https://img.shineinto.com/static/logo.svg"
      class="logo"
      @click="handleLogoClick"
    />
    <i
      v-if="mobileMenuVisible"
      class="el-icon-close"
      @click.stop="handleMobileMenuClose"
    ></i>
    <img
      v-else
      class="menu-icon"
      src="https://img.shineinto.com/static/menu.png"
      @click="mobileMenuVisible = true"
    />
    <div
      class="header-right"
      @mouseenter="handleNavMouseEnter"
      @mousemove="handleNavMouseEnter"
      @mouseleave="currentIndex = -1"
    >
      <ul class="nav-list">
        <li
          v-for="page in pages"
          :key="page.path"
          ref="navItems"
          :class="{
            active:
              $route.path === page.path ||
              (page.children &&
                page.children.some((child) => $route.path === child.path)),
          }"
        >
          <router-link :to="page.path">{{ page.name }}</router-link>
        </li>
      </ul>
      <div class="language-box">
        <el-dropdown @command="handleLanguage">
          <div class="language-container">
            <span>
              {{ languageText }}
            </span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh-CN">{{
              $t("language.zh")
            }}</el-dropdown-item>
            <el-dropdown-item command="en">{{
              $t("language.en")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 添加动画效果 从上至下展开 -->
      <transition v-if="page && page.children" name="slide-down">
        <ul class="children-list" @mousemove.stop.prevent>
          <li
            v-for="child in page.children || []"
            :key="child.path"
            :class="{
              active: $route.path === child.path,
            }"
          >
            <router-link :to="child.path">{{ child.name }}</router-link>
          </li>
        </ul>
      </transition>
    </div>
    <!-- 移动端菜单 -->
    <el-drawer
      :visible.sync="mobileMenuVisible"
      direction="rtl"
      custom-class="mobile-menu-drawer"
      :withHeader="false"
      :show-close="false"
      :modal="false"
    >
      <div class="mobile-menu">
        <div
          v-for="page in pages"
          :key="page.path"
          :class="{
            active: $route.path === page.path,
            'mobile-menu-item': true,
          }"
          @click="handleMobileMenuItemClick(page)"
        >
          <span>{{ page.name }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-drawer
        :visible.sync="mobileSubMenuVisible"
        direction="rtl"
        custom-class="mobile-menu-drawer"
        :withHeader="false"
        :show-close="false"
        :modal="false"
        :append-to-body="true"
      >
        <div class="mobile-menu" v-if="currentIndex !== -1">
          <div
            class="mobile-sub-menu-header mobile-menu-item"
            @click="handleMobileSubMenuHeaderClick"
          >
            <i class="el-icon-arrow-left"></i>
            <span>{{ pages[currentIndex].name }}</span>
          </div>
          <div
            v-for="child in (pages[currentIndex] &&
              pages[currentIndex].children) ||
            []"
            :key="child.path"
            :class="{
              active: $route.path === child.path,
              'mobile-menu-item': true,
            }"
            @click="handleMobileSubMenuItemClick(child)"
          >
            <span>{{ child.name }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </el-drawer>
    </el-drawer>
  </header>
</template>

<script>
export default {
  name: "CustomHeader",
  data() {
    return {
      currentIndex: -1,
      mobileMenuVisible: false,
      mobileSubMenuVisible: false,
    };
  },
  computed: {
    pages() {
      return [
        {
          name: this.$t("nav.brand"),
          path: "/",
          active: this.$route.path === "/",
          children: [
            {
              name: this.$t("nav.brandStory"),
              path: "/",
              active: this.$route.path === "/",
            },
            {
              name: this.$t("nav.designerStory"),
              path: "/designer-story",
              active: this.$route.path === "/designer-story",
            },
            {
              name: this.$t("nav.brandCraftsmanship"),
              path: "/brand-craftsmanship",
              active: this.$route.path === "/brand-craftsmanship",
            },
            {
              name: this.$t("nav.brandBlockbuster"),
              path: "/brand-blockbuster",
              active: this.$route.path === "/brand-blockbuster",
            },
            // {
            //   name: this.$t("nav.brandHonor"),
            //   path: "/brand-honor",
            //   active: this.$route.path === "/brand-honor",
            // },
          ],
        },
        {
          name: this.$t("nav.news"),
          path: "/news/latest",
          active: this.$route.path.startsWith("/news"),
          children: [
            {
              name: this.$t("nav.latest"),
              path: "/news/latest",
              active: this.$route.path === "/news/latest",
            },
            {
              name: this.$t("nav.media"),
              path: "/news/media",
              active: this.$route.path === "/news/media",
            },
            {
              name: this.$t("nav.activity"),
              path: "/news/activity",
              active: this.$route.path === "/news/activity",
            },
            {
              name: this.$t("nav.trend"),
              path: "/news/trend",
              active: this.$route.path === "/news/trend",
            },
          ],
        },
        {
          name: this.$t("nav.map"),
          path: "/map",
          active: this.$route.path === "/map",
        },
        {
          name: this.$t("nav.contact"),
          path: "/contact",
          active: this.$route.path === "/contact",
        },
      ];
    },
    page() {
      return this.currentIndex >= 0 ? this.pages[this.currentIndex] : null;
    },
    // 获取当前语言
    currentLanguage() {
      return this.$store.getters["language/getCurrentLanguage"];
    },
    // 获取语言显示文本
    languageText() {
      return this.$store.getters["language/getLanguageText"];
    },
  },
  methods: {
    handleNavMouseEnter(e) {
      const list = Array.from(this.$refs.navItems);
      const index = list.findIndex((item) => item.contains(e.target));
      if (index !== -1) {
        this.currentIndex = index;
      }
    },
    // 处理语言切换
    handleLanguage(language) {
      this.$store.dispatch("language/setLanguage", language);
    },
    handleLogoClick() {
      if (this.$route.path === "/") {
        return;
      }
      this.mobileMenuVisible = false;
      this.mobileSubMenuVisible = false;
      this.$router.push("/");
    },
    handleMobileMenuItemClick(page) {
      if (page.children && page.children.length > 0) {
        this.mobileSubMenuVisible = true;
        this.currentIndex = this.pages.findIndex((p) => p.path === page.path);
      } else {
        if (this.$route.path === page.path) {
          return;
        }
        this.mobileMenuVisible = false;
        this.$router.push(page.path);
      }
    },
    handleMobileSubMenuItemClick(child) {
      if (this.$route.path === child.path) {
        return;
      }
      this.mobileSubMenuVisible = false;
      this.mobileMenuVisible = false;
      this.$router.push(child.path);
    },
    handleMobileSubMenuHeaderClick() {
      this.mobileSubMenuVisible = false;
    },
    handleMobileMenuClose() {
      this.mobileSubMenuVisible = false;
      this.mobileMenuVisible = false;
    },
  },
  mounted() {
    // 组件挂载时，从 localStorage 恢复语言设置
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      this.$store.commit("language/SET_LANGUAGE", savedLanguage);
    }
  },
};
</script>

<style scoped lang="less">
@keyframes navSlideUp {
  0% {
    transform: translate3d(0, 10px, 0);
    opacity: 0;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0 86px;
  background-color: #fff;
  height: 114px;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #e5e5e5;
  .logo {
    width: 117px;
    height: 47px;
    cursor: pointer;
  }
  .menu-icon {
    display: none;
  }
  .header-right {
    display: flex;
    align-items: center;
    .language-box {
      height: 114px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 42px;
      .language-container {
        cursor: pointer;
        display: flex;
        gap: 6ths px;
        align-items: center;
        line-height: 28px;
        color: rgba(33, 30, 29, 1);
        font-size: 20px;
      }
    }
  }
  ul {
    display: flex;
    list-style: none;
    height: 100%;
    li {
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        padding: 0 42px;
        line-height: 114px;
        color: rgba(33, 30, 29, 1);
        font-size: 20px;
        text-decoration: none;
      }
      &.active,
      &:hover {
        > a {
          font-weight: bold;
        }
      }
    }
  }
  .children-list {
    position: absolute;
    left: 0;
    right: 0;
    top: 112px;
    height: 114px;
    margin: 0 auto;
    background-color: #f7f7f7;
    z-index: 100;
    justify-content: flex-end;
    overflow: hidden;
    a {
      position: relative;
      animation: navSlideUp 0.8s;
    }
  }
}
.desktop-only .children-list {
  // max-width: 1920px;
}
/* 进入和离开的开始状态 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.2s ease; /* 定义过渡效果 */
}

/* 进入和离开的结束状态 */
.slide-down-enter,
.slide-down-leave-to {
  // max-height: 0; /* 开始时高度为0 */
  opacity: 0;
}

.slide-down-enter-to,
.slide-down-leave {
  // max-height: 114px; /* 这里可以根据实际内容调整，确保有足够的空间 */
  opacity: 1;
  a {
    transform: translateY(0);
  }
}
</style>

<style lang="less" scoped>
@media screen and (max-width: 48rem) {
  header {
    height: 62px;
    padding-left: 32px;
    padding-right: 32px;
    border-bottom-width: 1px;
    background-color: #fff;
    border-bottom-color: #fff;

    .logo {
      width: 58px;
      height: 23px;
    }
    .menu-icon {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
    .nav-list,
    .children-list,
    .header-right {
      display: none !important;
    }
  }
}
</style>

<style lang="less">
@media screen and (max-width: 48rem) {
  .el-drawer__wrapper {
    top: 62px !important;
  }
  .mobile-menu-drawer {
    width: 100% !important;
    box-shadow: none !important;
    .mobile-menu {
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      .mobile-menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 60px;
        font-size: 14px;
        padding-right: 2px;
        color: #535252;
        &:after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          border-top: 1px solid #e5e5e5;
          transform: scaleY(0.5);
        }
        &.active {
          font-weight: bold;
        }
      }
      .mobile-sub-menu-header {
        justify-content: flex-start;
        gap: 8px;
      }
    }
  }
}
</style>
